(function () {
  /**
   * @typedef SearchResult
   * @type {object}
   * @property {string|null} id
   * @property {string} name
   */

  /**
   * @typedef {SearchCache}
   * @type {Record<string, SearchResult>}
   */

  /**
   * @param {*} data
   * @return {SearchResult}
   */
  function createResult(data) {
    return {
      id: data.place_id ? data.place_id : null,
      name: data.description,
    };
  }

  var suggestionWrapperClassName = 'worst-cycling-lane__suggestions';

  this.LocationService = function (plugin) {
    this.plugin = plugin;

    this.autocompleteService = null;

    this.placesService = null;

    this.lastRequest = null;

    /**
     * @type {SearchResult[]}
     */
    this.results = [];

    /**
     * @type {SearchCache}
     */
    this.searchCache = {};

    /**
     * @type {number|null}
     */
    this.searchThrottle = null;

    this.removeResults = function () {
      this.results = [];
    }.bind(this);

    /**
     * @param {SearchResult} searchResult
     * @param {HTMLElement} inputElement
     */
    this.selectSuggestion = function (searchResult, inputElement) {
      inputElement.value = searchResult.name;
      this.removeResults();
      this.injectResults(inputElement);
      if (!this.placesService) {
        this.placesService = new google.maps.places.PlacesService(
          new google.maps.Map(document.createElement('div'))
        );
      }

      var countrySelect = document.getElementById('wcl-country');

      if (searchResult.id && countrySelect) {
        this.placesService.getDetails(
          {
            placeId: searchResult.id,
            fields: ['address_components'],
          },
          function (result) {
            if (result.address_components) {
              for (
                var componentIndex = 0;
                componentIndex < result.address_components.length;
                componentIndex++
              ) {
                var component = result.address_components[componentIndex];
                if (component.types.indexOf('country') >= 0) {
                  var option = countrySelect.querySelector(
                    '[value="' + component.short_name + '"]'
                  );
                  if (option) {
                    option.selected = 'selected';
                    if ('Event' in window && 'dispatchEvent' in window) {
                      countrySelect.dispatchEvent(new Event('change'));
                    }
                  }
                  return;
                }
              }
            }
          }.bind(this)
        );
      }
    };

    /**
     * Creates DOM Elements with suggestions
     * @param {SearchResult[]} searchResults
     * @param {HTMLElement} inputElement
     * @return {HTMLElement}
     */
    this.createSuggestions = function (searchResults, inputElement) {
      /**
       * @type {HTMLUListElement}
       */
      var wrapper = document.createElement('ul');
      wrapper.classList.add(suggestionWrapperClassName);
      for (var index = 0; index < searchResults.length; index++) {
        var result = searchResults[index];
        /**
         * @type {HTMLLIElement}
         */
        var item = document.createElement('li');
        item.classList.add('worst-cycling-lane__suggestions__item');
        item.innerHTML = result.name;
        this.plugin.BindClick(
          item,
          function (boundResult, boundInputElement) {
            return function () {
              this.selectSuggestion(boundResult, boundInputElement);
            }.bind(this);
          }.bind(this)(result, inputElement)
        );
        wrapper.appendChild(item);
      }

      return wrapper;
    }.bind(this);

    /**
     * Searches an input in google maps places
     * @param {string} value
     * @returns {Promise<SearchResult[]>}
     */
    this.search = function (value) {
      if (!this.autocompleteService) {
        this.autocompleteService = new google.maps.places.AutocompleteService();
      }
      return new Promise(
        function (resolve) {
          this.autocompleteService.getPlacePredictions(
            {
              input: value,
            },
            function (list, status) {
              if (status === 'OK' && list !== null && list.length > 0) {
                resolve(list.map(createResult));
              } else {
                resolve([]);
              }
            }.bind(this)
          );
        }.bind(this)
      );
    }.bind(this);

    /**
     * @param {HTMLInputElement} inputElement
     */
    this.injectResults = function (inputElement) {
      if (inputElement.parentNode) {
        var wrapper = inputElement.parentNode.querySelector(
          '.' + suggestionWrapperClassName
        );
        if (wrapper) {
          inputElement.parentNode.removeChild(wrapper);
        }
        wrapper = this.createSuggestions(this.results, inputElement);
        inputElement.parentNode.appendChild(wrapper);
      }
    }.bind(this);

    this.changeListener = function (e) {
      if (this.searchThrottle) {
        clearTimeout(this.searchThrottle);
      }

      var inputElement = e.currentTarget;

      var value = inputElement.value.trim();

      this.searchThrottle = setTimeout(
        function () {
          var lastRequest = Date.now();

          var promise = new Promise(
            function (resolve) {
              this.lastRequest = lastRequest;
              if (!value) {
                this.removeResults();
                resolve();
              } else if (this.searchCache[value]) {
                this.results = this.searchCache[value];
                resolve();
              } else {
                this.search(value).then(
                  function (searchResults) {
                    this.results = searchResults;
                    // Add result based on user search
                    this.results.unshift(createResult({ description: value }));
                    resolve();
                  }.bind(this)
                );
              }
            }.bind(this)
          );

          promise.then(
            function () {
              if (lastRequest === this.lastRequest) {
                this.injectResults(inputElement);
              }
            }.bind(this)
          );
        }.bind(this),
        250
      );
    }.bind(this);
  };

  /**
   * @param {HTMLInputElement} input
   * @throws {Error}
   */
  this.LocationService.prototype.BindLocation = function (input) {
    if (!input || typeof input !== 'object' || input.tagName !== 'INPUT') {
      this.plugin.Logger.Debug(
        'Invalid input provided for location binding',
        input
      );
      throw new Error('input.invalid');
    }

    input.addEventListener('input', this.changeListener.bind(this));
  };
}).bind(window.WorstCyclingLane)();
